import { Ref } from 'react'

export function setOptionRef(ref: Ref<HTMLDivElement> | undefined, node: HTMLDivElement | null) {
    if (!ref) return
    if (typeof ref === 'function') {
        ref(node)
        return
    }
    ref.current = node
}
